import "../../../../../../../node_modules/bxslider/dist/jquery.bxslider.js";
import {PewComponent} from "../../../assets/raw/js/components/pew-component";

// see https://bxslider.com/options/
const SliderOptions = {
    minSlides: 1,
    moveSlides: 1,
    slideMargin: 20,
    shrinkItems: true,
    pause: 2000,
    randomStart: false,
    wrapperClass: "wdf-slider-trombi-wrapper",
    adaptiveHeight: true,
    auto: true,
    stopAutoOnClick: true,
    touchEnabled: (window.innerWidth < 1025)
};

export class SliderTrombiComponent extends PewComponent {
    constructor(element) {
        super(element, SliderOptions);
    }

    init() {
        let isMobile = (window.innerWidth < 768);
        jQuery(window).on("load", ()=>{
            if(isMobile){
                this.options['maxSlides']  = 1;
                this.options['slideMargin']  = 0;
                this.options['shrinkItems']  = false;
            } else {
                this.computeCarouselOptions();
            }
            this.element.bxSlider(this.options);
            setTimeout(()=>{
                this.element.redrawSlider();
            },500);
        });
    }

    computeCarouselOptions() {
        let vw            = this.element.width(),
            slideMinWidth = 160,
            numOfSlides   = this.element.find('> *').length + 1;

        let candidateSlideWidth = 0;

        do {
            numOfSlides--;
            candidateSlideWidth = Math.floor(vw / numOfSlides);
        } while (candidateSlideWidth < slideMinWidth);

        this.options['slideWidth'] = candidateSlideWidth;
        this.options['maxSlides']  = numOfSlides;
    }
}

window.pew.addRegistryEntry({key: 'wdf-slider-cpt', domSelector: '.wdf-slider-trombi', classDef: SliderTrombiComponent});





// WEBPACK FOOTER //
// ./web/app/themes/wwp_child_theme/includes/Components/Trombinoscope/SliderTrombiComponent.js